import(/* webpackMode: "eager" */ "/vercel/path0/app/talento/page.tsx");
